export function updateBorderRadius(
    borderRadius,
    PropertyName,
    ContentId,
    StyleId
){
    const states = ['hover', 'normal'];
    const devices = {
        mobile: ['mobile', 'tablet', 'desktop'],
        tablet: ['tablet', 'desktop'],
        desktop: ['desktop']
    };

    states.forEach(state => {
        Object.keys(devices).forEach(device => {
            const stateFallback = state === 'hover' ? ['hover', 'normal'] : ['normal'];
            const deviceFallback = devices[device];

            const borderRadiusStyles = {
                'borderTopLeftRadius': getBorderRadiusValue(borderRadius, stateFallback, deviceFallback, 'topLeft'),
                'borderTopRightRadius': getBorderRadiusValue(borderRadius, stateFallback, deviceFallback, 'topRight'),
                'borderBottomLeftRadius': getBorderRadiusValue(borderRadius, stateFallback, deviceFallback, 'bottomLeft'),
                'borderBottomRightRadius': getBorderRadiusValue(borderRadius, stateFallback, deviceFallback, 'bottomRight')
            };

            applyDynamicStyle(
                getQueryFromString(device),
                `.${PropertyName}-${state}-${ContentId}`,
                borderRadiusStyles,
                StyleId
            );
        });
    });
}
export function getBorderRadiusValue(borderRadius, stateFallback, deviceFallback, property) {
    for (let state of stateFallback) {
        for (let device of deviceFallback) {
            const radiusValue = borderRadius[state]?.[device]?.[property];
            const unit = borderRadius[state]?.[device]?.[property + 'Unit'];
            if (radiusValue) {
                return radiusValue + unit;
            }
        }
    }
    return ''; // Return empty if no value found
}
export function previewHoverStyle(
    backgroundStyle
) {
    if (backgroundStyle.hover.gradientType === 'radial') {
        return `background: radial-gradient(${backgroundStyle.hover.radialShape} at ${backgroundStyle.hover.radialDirection}, ${backgroundStyle.hover.gradientFrom} ${backgroundStyle.hover.startPosition}%, ${backgroundStyle.hover.gradientTo} ${backgroundStyle.hover.endPosition}%)`;
    }
    return `background: linear-gradient(${backgroundStyle.hover.gradientDirection}deg, ${backgroundStyle.hover.gradientFrom} ${backgroundStyle.hover.startPosition}%, ${backgroundStyle.hover.gradientTo} ${backgroundStyle.hover.endPosition}%)`;
}
export function previewNormalStyle(
    backgroundStyle
) {
    if (backgroundStyle.normal.gradientType === 'radial') {
        return `background: radial-gradient(${backgroundStyle.normal.radialShape} at ${backgroundStyle.normal.radialDirection}, ${backgroundStyle.normal.gradientFrom} ${backgroundStyle.normal.startPosition}%, ${backgroundStyle.normal.gradientTo} ${backgroundStyle.normal.endPosition}%)`;
    }
    return `background: linear-gradient(${backgroundStyle.normal.gradientDirection}deg, ${backgroundStyle.normal.gradientFrom} ${backgroundStyle.normal.startPosition}%, ${backgroundStyle.normal.gradientTo} ${backgroundStyle.normal.endPosition}%)`;
}
export function updateHoverGradient(
    backgroundStyle,
    selectedDevice,
    PropertyName,
    ContentId,
    StyleId
) {
    applyDynamicStyle(getQueryFromString(selectedDevice), `.`+ PropertyName + `-hover-` + ContentId,
        {
            'background':  appendHoverStyle(backgroundStyle)
        }, StyleId);
}

export function  appendHoverStyle(backgroundStyle) {
    if (backgroundStyle.hover.gradientType === 'radial') {
        return `radial-gradient(${backgroundStyle.hover.radialShape} at ${backgroundStyle.hover.radialDirection}, ${backgroundStyle.hover.gradientFrom} ${backgroundStyle.hover.startPosition}%, ${backgroundStyle.hover.gradientTo} ${backgroundStyle.hover.endPosition}%)`;
    }
    return `linear-gradient(${backgroundStyle.hover.gradientDirection}deg, ${backgroundStyle.hover.gradientFrom} ${backgroundStyle.hover.startPosition}%, ${backgroundStyle.hover.gradientTo} ${backgroundStyle.hover.endPosition}%)`;
}
export function updateNormalGradient(
    backgroundStyle,
    selectedDevice,
    PropertyName,
    ContentId,
    StyleId
){
    if ((backgroundStyle.hover.backgroundType === 'color') && (backgroundStyle.hover.color === '' || backgroundStyle.hover.color === null)) {
        applyDynamicStyle(getQueryFromString(selectedDevice), `.`+ PropertyName + `-hover-` + ContentId,
            {
                'background':  appendNormalStyle(backgroundStyle)
            }, StyleId);
    }

    applyDynamicStyle(getQueryFromString(selectedDevice), `.`+ PropertyName + `-normal-` + ContentId,
        {
            'background':  appendNormalStyle(backgroundStyle)
        }, StyleId);
}
export function appendNormalStyle(backgroundStyle) {
    if (backgroundStyle.normal.gradientType === 'radial') {
        return `radial-gradient(${backgroundStyle.normal.radialShape} at ${backgroundStyle.normal.radialDirection}, ${backgroundStyle.normal.gradientFrom} ${backgroundStyle.normal.startPosition}%, ${backgroundStyle.normal.gradientTo} ${backgroundStyle.normal.endPosition}%)`;
    }
    return `linear-gradient(${backgroundStyle.normal.gradientDirection}deg, ${backgroundStyle.normal.gradientFrom} ${backgroundStyle.normal.startPosition}%, ${backgroundStyle.normal.gradientTo} ${backgroundStyle.normal.endPosition}%)`;
}
export function updateHoverColor(
    color,
    PropertyName,
    ContentId,
    StyleId
) {
    const hoverClass = `.${PropertyName}-hover-${ContentId}`;

    // Apply hover color only if it hasn't been set; otherwise, fallback to normal or null
    const hoverColor = color.hover || color.normal || null;
    applyDynamicStyle(null, hoverClass, { 'color': hoverColor }, StyleId);
}
export function updateBackgroundColor(
    backgroundType,
    backgroundStyle,
    selectedDevice,
    PropertyName,
    ContentId,
    StyleId
) {
    // Apply the main background style
    applyDynamicStyle(
        getQueryFromString(selectedDevice),
        `.${PropertyName}-${backgroundType}-${ContentId}`,
        {
            'background': 'none',
            'backgroundColor': backgroundStyle[backgroundType].color
        }, // Use extracted style
        StyleId
    );

    // Apply hover style only if condition matches
    if (backgroundStyle.hover.color === '' || backgroundStyle.hover.color === null) {
        applyDynamicStyle(
            getQueryFromString(selectedDevice),
            `.${PropertyName}-hover-${ContentId}`,
            {
                'background': 'none',
                'backgroundColor': backgroundStyle.normal.color
            }, // Use extracted style
            StyleId
        );
    }
}
export function updateSpacing(
    letterSpacing,
    selectedDevice,
    PropertyName,
    ContentId,
    StyleId
) {
    const deviceQuery = getQueryFromString(selectedDevice);
    const letterSpacingRes = letterSpacing[selectedDevice] + letterSpacing[selectedDevice + 'Unit'];

    // Ensure letterSpacing is a valid string and not undefined
    if (letterSpacingRes) {
        // Define the class names for normal and hover states
        ['normal', 'hover'].forEach(state => {
            const className = `.${PropertyName}-${state}-${ContentId}`;
            applyDynamicStyle(deviceQuery, className, { 'letterSpacing': letterSpacingRes }, StyleId);
        });

        if (selectedDevice === 'tablet' && letterSpacing.mobile === '') {
            ['normal', 'hover'].forEach(state => {
                const className = `.${PropertyName}-${state}-${ContentId}`;
                applyDynamicStyle(getQueryFromString('mobile'), className, { 'letterSpacing': letterSpacingRes }, StyleId);
            });
        }
    } else {
        console.error('Invalid letter spacing for the selected device:', selectedDevice);
    }
}
export function updateLineHeight(
    lineHeight,
    selectedDevice,
    PropertyName,
    ContentId,
    StyleId
) {
    const deviceQuery = getQueryFromString(selectedDevice);
    const lineHeightRes = lineHeight[selectedDevice] + lineHeight[selectedDevice + 'Unit'];

    // Ensure lineHeight is a valid string and not undefined
    if (lineHeightRes) {
        // Define the class names for normal and hover states
        ['normal', 'hover'].forEach(state => {
            const className = `.${PropertyName}-${state}-${ContentId}`;
            applyDynamicStyle(deviceQuery, className, { 'lineHeight': lineHeightRes }, StyleId);
        });

        if (selectedDevice === 'tablet' && lineHeight.mobile === '') {
            ['normal', 'hover'].forEach(state => {
                const className = `.${PropertyName}-${state}-${ContentId}`;
                applyDynamicStyle(getQueryFromString('mobile'), className, { 'lineHeight': lineHeightRes }, StyleId);
            });
        }
    } else {
        console.error('Invalid line height for the selected device:', selectedDevice);
    }
}

export function updatePaddings(
    padding,
    selectedDevice,
    PropertyName,
    ContentId,
    StyleId
) {
    const deviceQuery = getQueryFromString(selectedDevice);

    // Get current padding values for the selected device
    const currentPaddings = padding[selectedDevice];

    // Prepare the padding styles for the selected device
    let paddingsStyles = {
        'paddingBottom': currentPaddings.bottom + currentPaddings.bottomUnit,
        'paddingTop': currentPaddings.top + currentPaddings.topUnit,
        'paddingLeft': currentPaddings.left + currentPaddings.leftUnit,
        'paddingRight': currentPaddings.right + currentPaddings.rightUnit
    };

    // Define the class names for normal and hover states
    ['normal', 'hover'].forEach(state => {
        const className = `.${PropertyName}-${state}-${ContentId}`;
        applyDynamicStyle(deviceQuery, className, paddingsStyles, StyleId);
    });

    if (selectedDevice === 'desktop') {
        const priorityList = ['tablet', 'desktop'];
        paddingsStyles = {
            'paddingBottom': getPaddingValue(padding, priorityList, 'bottom', currentPaddings),
            'paddingTop': getPaddingValue(padding, priorityList, 'top', currentPaddings),
            'paddingLeft': getPaddingValue(padding, priorityList, 'left', currentPaddings),
            'paddingRight': getPaddingValue(padding, priorityList, 'right', currentPaddings)
        };

        ['normal', 'hover'].forEach(state => {
            const className = `.${PropertyName}-${state}-${ContentId}`;
            applyDynamicStyle(getQueryFromString('tablet'), className, paddingsStyles, StyleId);
        });
    } else if (selectedDevice === 'tablet') {
        const priorityList = ['mobile', 'tablet', 'desktop'];
        paddingsStyles = {
            'paddingBottom': getPaddingValue(padding, priorityList, 'bottom', currentPaddings),
            'paddingTop': getPaddingValue(padding, priorityList, 'top', currentPaddings),
            'paddingLeft': getPaddingValue(padding, priorityList, 'left', currentPaddings),
            'paddingRight': getPaddingValue(padding, priorityList, 'right', currentPaddings)
        };

        ['normal', 'hover'].forEach(state => {
            const className = `.${PropertyName}-${state}-${ContentId}`;
            applyDynamicStyle(getQueryFromString('mobile'), className, paddingsStyles, StyleId);
        });
    }
}

export function getPaddingValue(padding, priorityList, side, currentPaddings) {
    for (let device of priorityList) {
        if (padding[device][side] !== '') {
            return padding[device][side] + padding[device][side + 'Unit'];
        }
    }
    return currentPaddings[side] + currentPaddings[side + 'Unit'];
}
export function updateColor(
    color,
    PropertyName,
    ContentId,
    StyleId
) {
    const normalClass = `.${PropertyName}-normal-${ContentId}`;
    const hoverClass = `.${PropertyName}-hover-${ContentId}`;
    // Apply normal color
    this.applyDynamicStyle(null, normalClass, { 'color': color.normal }, StyleId);

    // Only apply hover color if it hasn't been set
    if (!color.hover) {
        applyDynamicStyle(null, hoverClass, { 'color': color.normal }, StyleId);
    }
}
export function updateFontWeight(
    font,
    PropertyName,
    ContentId,
    StyleId
) {
    const styleObject = {
        'fontWeight': font.weight
    };

    ['normal', 'hover'].forEach(state => {
        const className = `.${PropertyName}-${state}-${ContentId}`;
        this.applyDynamicStyle(null, className, styleObject, StyleId);
    });
}
export function updateFontFamily(
    font,
    PropertyName,
    ContentId,
    StyleId
) {
    const styleObject = {
        'fontFamily': font.family
    };

    ['normal', 'hover'].forEach(state => {
        const className = `.${PropertyName}-${state}-${ContentId}`;
        applyDynamicStyle(null, className, styleObject, StyleId);
    });
}
export function updateFontSize(
    selectedDevice,
    fontSize,
    PropertyName,
    ContentId,
    StyleId
) {
    const deviceQuery = getQueryFromString(selectedDevice);
    const size = fontSize[selectedDevice] + "px"; // Get the font size based on the current device

    // Define the class names for normal and hover states
    ['normal', 'hover'].forEach(state => {
        const className = `.${PropertyName}-${state}-${ContentId}`;
        applyDynamicStyle(deviceQuery, className, { 'fontSize': size }, StyleId);
    });

    if (selectedDevice === 'tablet' && fontSize.mobile === '') {
        ['normal', 'hover'].forEach(state => {
            const className = `.${PropertyName}-${state}-${ContentId}`;
            applyDynamicStyle(getQueryFromString('mobile'), className, { 'fontSize': size }, StyleId);
        });
    }
}

export function getQueryFromString(selectedDevice) {
    let mediaQuery = null;

    if (selectedDevice === "desktop") {
        mediaQuery = null;
    } else if (selectedDevice === "tablet") {
        mediaQuery = "(min-width: 768px) and (max-width: 1024px)";
    } else if (selectedDevice === "mobile") {
        mediaQuery = "(max-width: 767px)";
    }

    return mediaQuery;
}

export function applyDynamicStyle(mediaQuery, className, cssProperties, styleId) {
    const iframe = document.querySelector('iframe');
    if (!iframe) {
        console.error('Iframe not found.');
        return;
    }
    const iframeDocument = iframe.contentWindow.document;
    if (!iframeDocument) {
        console.error('Unable to access iframe document.');
        return;
    }

    // Select ALL style tags with the duplicated styleId
    const styleTags = iframeDocument.querySelectorAll(`style#${styleId}`);

    if (styleTags.length === 0) {
        console.error(`No style tags found with id "${styleId}"`);
        return;
    }

    styleTags.forEach(styleTag => {
        const sheet = [...iframeDocument.styleSheets].find(sheet => sheet.ownerNode === styleTag);

        if (!sheet) {
            console.error(`Stylesheet for style tag with id "${styleId}" not found.`);
            return;
        }

        try {
            const rules = [...sheet.cssRules];
            let classRuleFound = false;

            // Check inside media queries first
            rules.forEach(rule => {
                if (rule.media && rule.media.mediaText === mediaQuery) {
                    [...rule.cssRules].forEach(innerRule => {
                        if (innerRule.selectorText === className) {
                            if (cssProperties === null) {
                                clearCSSRule(innerRule);
                            } else {
                                updateCSSRule(innerRule, cssProperties);
                                classRuleFound = true;
                            }
                        }
                    });
                }
            });

            // If not found inside media queries, check outside
            if (!classRuleFound) {
                rules.forEach(rule => {
                    if (!rule.media && rule.selectorText === className) {
                        if (cssProperties === null) {
                            clearCSSRule(rule);
                        } else {
                            updateCSSRule(rule, cssProperties);
                            classRuleFound = true;
                        }
                    }
                });
            }

            if (!classRuleFound) {
                console.warn(`No matching class "${className}" found in or outside the media query.`);
            }
        } catch (e) {
            console.warn('Unable to access stylesheet: ', e);
        }
    });
}

export function clearCSSRule(rule) {
    if (rule.style) {
        // Loop through each style property and reset it
        for (let i = rule.style.length - 1; i >= 0; i--) {
            const propertyName = rule.style[i];
            rule.style.removeProperty(propertyName);
        }
    }
}

export function updateCSSRule(rule, cssProperties) {
    // Iterate over the properties and set them in the rule
    Object.keys(cssProperties).forEach(property => {
        rule.style[property] = cssProperties[property];
    });
}
